export const getData = async ({ setLoading, setError, setData, client, search }) => {
  try {
    setLoading(true)
    const response = await client({ search })
    setData(response.data)
    setError(false)
  } catch (e) {
    setError(true)
    setData(null)
  }
  setLoading(false)
}

export const clearInput = (inputEl) => {
  let elemInput = inputEl.current.querySelector('input')
  elemInput.value = ''
}
